module.exports = __webpack_public_path__ + "img/paytype-bottom-hen.90e62b60.png";